import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CommonPageRoutingModule } from './common-routing.module';

import { CommonPage } from './common.page';
import { PickDeviceTypeComponent } from './components/pick-device-type/pick-device-type.component';
import { SharedModule } from 'src/app/core/modules/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { EnterDeviceComponent } from './components/enter-device/enter-device.component';
import { LaterPageComponent } from './components/later-page/later-page.component';
import { EnterConfirmIdComponent } from './components/enter-confirm-id/enter-confirm-id.component';
import { FarmSaveFormComponent } from './components/farm-save-form/farm-save-form.component';
import { FarmDeviceDetailComponent } from './components/farm-device-detail/farm-device-detail.component';
import { UntilDayPipe } from './pipes/until-day.pipe';
import { SprayingComponent } from './components/spraying/spraying.component';
import { AddSprayingComponent } from './components/add-spraying/add-spraying.component';
import { CalendarPickerModule } from 'src/app/core/modules/calendar-picker.module';
import { AddTimelineComponent } from './components/add-timeline/add-timeline.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { FindFieldComponent } from './components/find-field/find-field.component';
import { FarmDrawingToolsModule } from 'src/app/core/modules/farm-drawing-tools.module';
import { IconModule } from 'src/app/core/modules/icon.module';
import { AlertModule } from 'src/app/core/modules/alert.module';
import { GenericMapModule } from 'src/app/core/modules/generic-map.module';
import { AddFieldHintComponent } from './components/add-field-hint/add-field-hint.component';
import { FarmSaveSucessComponent } from './components/farm-save-sucess/farm-save-sucess.component';
import { ParcelInquiryComponent } from './components/parcel-inquiry/parcel-inquiry.component';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { AddFieldComponent } from './components/add-field/add-field.component';
import { ProfilePageModule } from './profile/profile.module';
import { FarmModule } from 'src/app/core/modules/farm.module';
import { FarmMapPageModule } from './farm-map/farm-map.module';
import { RouterModule } from '@angular/router';
import { UnitPreferenceModule } from 'src/app/core/modules/unit-preferences.module';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { FarmEditComponent } from './components/farm-edit/farm-edit.component';
import { SprayingHoursComponent } from './components/spraying-hours/spraying-hours.component';
import { SprayinHoursArcComponent } from './components/spraying-hours/components/sprayin-hours-arc/sprayin-hours-arc.component';
import { DeviceUpdateComponent } from './components/device-update/device-update.component';
import { DeviceLocationComponent } from './components/device-location/device-location.component';
import { PickDeviceTypePairComponent } from './components/pick-device-type-pair/pick-device-type-pair.component';
import { SensorSelectionComponent } from './components/sensor-selection/sensor-selection.component';
import { CustomErrorModalComponent } from 'src/app/core/helper/components/custom-error-modal/custom-error-modal.component';
import { CropInformationsEditComponent } from './components/crop-informations-edit/crop-informations-edit.component';
import { DeviceInfoUpdateComponent } from './components/device-info-update/device-info-update.component';
import { TimelineV2Component } from './components/timeline-v2/timeline-v2.component';
import { TimelineSaveSuccessComponent } from './components/timeline-save-success/timeline-save-success.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CommonPageRoutingModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    CalendarPickerModule,
    FarmDrawingToolsModule,
    IconModule,
    AlertModule,
    GenericMapModule,
    ProfilePageModule,
    FarmMapPageModule,
    FarmModule,
    RouterModule,
    UnitPreferenceModule
  ],
  declarations: [
    CommonPage,
    PickDeviceTypeComponent,
    PickDeviceTypePairComponent,
    EnterDeviceComponent,
    FarmSaveFormComponent,
    LaterPageComponent,
    EnterConfirmIdComponent,
    FarmDeviceDetailComponent,
    UntilDayPipe,
    AddSprayingComponent,
    SprayingComponent,
    TimelineComponent,
    AddTimelineComponent,
    FindFieldComponent,
    AddFieldHintComponent,
    FarmSaveSucessComponent,
    ParcelInquiryComponent,
    ErrorModalComponent,
    AddFieldComponent,
    NotificationListComponent,
    FarmEditComponent,
    SprayingHoursComponent,
    SprayinHoursArcComponent,
    DeviceUpdateComponent,
    DeviceLocationComponent,
    SensorSelectionComponent,
    CustomErrorModalComponent,
    CropInformationsEditComponent,
    DeviceInfoUpdateComponent,
    TimelineV2Component,
    TimelineSaveSuccessComponent
  ],
  exports: [
    AddSprayingComponent,
    SprayingComponent,
    TimelineComponent,
    AddTimelineComponent,
    AddFieldHintComponent, 
    FarmSaveSucessComponent, 
    ParcelInquiryComponent,
    FarmMapPageModule,
    ProfilePageModule,
    SprayingHoursComponent,
    SprayinHoursArcComponent,
    DeviceUpdateComponent,
    DeviceLocationComponent,
    SensorSelectionComponent,
    TimelineV2Component,
    TimelineSaveSuccessComponent
  ]
})
export class CommonPageModule { }
